import {useQuery} from '@tanstack/react-query';
import {GetBeneficiaryParams} from 'domain/usecases/others/selection-flow/beneficiary-v3';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getBeneficiaries} from '../../services/getBeneficiaries';

export const useGetBeneficiaries = (params: GetBeneficiaryParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.BENEFICIARIES, params, {excludeWalletCode: true}],
		queryFn: ({signal}) => getBeneficiaries({signal, ...params}),
	});
